import { AppStoreIcon } from '../../components/rentAndShare/AppStoreIcon';
import { GooglePlayIcon } from '../../components/rentAndShare/GooglePlayIcon';

export const hero100Page = {
  title: '100 % laddbart',
  image:
    'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/KIA-Elbilar-Range.jpg',
  mobileImage:
    'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/KIA-Elbilar-Range_mobile.jpg',
  position: 'top',
} as const;

export const text100page001 =
  'För oss på Kia har målet alltid varit att göra det möjligt för fler att välja elbil eller laddhybrid och vi strävar efter att 100 % av vår försäljning i Sverige ska vara laddbar. Redan 2014 var vi en tidig uppstickare på elbilsmarknaden när vi lanserade vår första elbil i Sverige, Kia Soul EV, och sedan dess har vi introducerat flera omtyckta elbilar och laddhybrider på den svenska marknaden. Genom att kontinuerligt utöka vårt modellprogram kommer vi kunna erbjuda en elbil för alla, i alla segment – och det kommer vara avgörande för att vi ska nå vårt mål. Tack för att du är med oss på resan.';

export const textBox100Page = {
  title: '',
  backgroundColor: '',
  numberOfFields: 3,
  titleStyle: 'mb-6 text-[32px] max-w-[627px]',
  textSize: 'text-lg leading-[24px]',
  listItems: [
    {
      text: '2024 var 85 % av vår försäljning i Sverige laddbar. Målet är 100 % laddbart.',
      boldParts: [''],

      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
    {
      text: 'Vi erbjuder elbilar och laddhybrider med hög teknik- och utrustningsnivå samt innovativa säkerhetssystem som standard.',
      boldParts: [''],
      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
    {
      text: 'Med ett brett modellprogram som ständigt utökas gör vi det möjligt för fler att köra laddbart från Kia.',
      boldParts: [''],
      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
  ],
};

export const imgAndTextCarCard100Page = {
  title: 'Tekniken som tar oss i mål.',
  cards: [
    {
      image:
        'https://kia-afonso-storage.b-cdn.net/100procent/EV3-ladda-ultrasnabbt.jpg',
      alt: 'kia car',
      title: 'Ladda snabbt och ultrasnabbt.',
      description:
        'Kia EV3 laddar snabbt och sömlöst från 10 till 80 procent på ner till 31 minuter. Tack vare 800-voltsteknik laddar Kia EV6 10 till 80 procent på ner till 18 minuter. Även Kia EV9 är utrustad med 800-voltsteknik, och den ultrasnabba laddningen går från 10 till 80 procent på ner till 24 minuter.',
      // link: 'https://www.kia.com/se/elbil/elbil/',
      linkText: 'Upptäck våra elbilar',
      openInNewTab: false,
      widthClass: 'w-full max-w-[300px]',
    },
    {
      image:
        'https://kia-afonso-storage.b-cdn.net/100procent/Kia-plattformen-gor-det.jpg',
      alt: 'kia car',
      title: 'Plattformen gör det möjligt.',
      description:
        '2027 kommer Kia att erbjuda 15 helt elektriska bilmodeller, som alla bygger på plattformen E-GMP. Plattformen omfattar elbilens alla viktiga komponenter som batteri, motor och drivlina. Eftersom hjulbasen är justerbar går plattformen att applicera på alla typer av bilmodeller, oavsett storlek – allt från crossovers till suvar och transportbilar.',
      // link: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/e-gmp',
      linkText: 'Läs mer om E-GMP',
      openInNewTab: false,
      widthClass: 'w-full max-w-[300px]',
    },

    {
      image:
        'https://kia-afonso-storage.b-cdn.net/100procent/EV6_GTL_MY25_LifstyleInterior_PhoneNavi_with_Talent.png',
      alt: 'kia car',
      title: 'En app för allt som rör din Kia.',
      description:
        'Aktivera ditt Kia Charge-kontrakt, fjärrstyr funktioner, få insikter kring kördata och fordonsstatus, navigera och boka verkstadsbesök. Kia App är nyckeln till ett enkelt bilägande, där allt är samlat på en och samma plats.',
      appLinks: [
        {
          text: 'Google Play',
          Icon: GooglePlayIcon,
          href: 'https://play.google.com/store/apps/details?id=com.kia.oneapp.kr&hl=en ',
        },
        {
          text: 'App Store',
          Icon: AppStoreIcon,
          href: 'https://apps.apple.com/se/app/kia-app/id6740517042',
        },
      ],
    },
  ],
};

export const subHeadingOne100Page = {
  text: 'Upptäck alla våra laddbara\n modeller.',
};

export const subHeadingTwo100Page = {
  text: 'Framtidens energilösningar i din Kia.',
};

export const kiaImageOne100Page = {
  src: 'https://kia-afonso-storage.b-cdn.net/100procent/Framtidens-Energilosningar.jpg',
  alt: 'KIA Car',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto py-4 w-full max-w-7xl object-cover object-center h-auto',
};

export const twoComponentsText100Page = {
  firstComponent: {
    title: 'Jämna ut effekttoppar med Vehicle-to-Grid.',
    text: 'Kia EV9, Kia EV6, Kia EV5, Kia EV4 och Kia EV3 har dubbelriktad laddning och är därmed förberedda för bland annat Vehicle-to-Grid (V2G)*. Det innebär att bilen kan användas för att lagra energi som sedan kan matas in i elnätet. På så sätt kan  elbilen spela en viktig roll för att jämna ut och stabilisera effekttoppar.',
    disclaimer: '* Beroende på modellversion.',
  },
  secondComponent: {
    title: 'Använd bilen som powerbank\n med Vehicle-to-Load.',
    text: 'Kia EV3, EV4, EV5, EV6 och EV9 har Vehicle-to-Load. Det innebär att du kan använda bilen som mobil powerbank och på så sätt utnyttja elbilens kapacitet till fullo. Bilen delar med sig av upp till 80 procent av batteriets kapacitet för att förse vad du än önskar med ström.',
    link: {
      url: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/vehicle-to-load/',
      text: 'Läs mer om V2L',
    },
  },
};

export const twoComponentsTextandImg100Page01 = {
  title: 'Nästa generations transportbilar.',
  text: 'Under samlingsnamnet PBV – platform beyond vehicle – lanserar Kia eldrivna transportbilar med start 2025. Tack vare integrerad, avancerad mjukvara, modulär konstruktion och exceptionell flexibilitet kan bilarna varieras och anpassas till olika branschers och kunders specifika krav inom betydligt vidare gränser än vad som tidigare varit möjligt. Först att lanseras är Kia PV5 Cargo L2H1, som har upp till 416 km räckvidd och kan snabbladdas från 10–80 % på ner till 30 minuter.',
  links: [
    {
      url: 'https://www.kia.com/se/pbv/modellutbud/pv5-cargo/',
      label: 'Läs mer om PV5 Cargo',
      openInNewTab: false,
    },
  ],
};

export const kiaImage100Page01 = {
  src: 'https://kia-afonso-storage.b-cdn.net/100procent/pv5-cargo-hero-vit.jpg',
  alt: 'KIA Car',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 py-4 w-full ',
};

export const twoComponentsTextandImg100Page02 = {
  title: 'Ladda 100 % förnybart hemma.',
  text: 'När du köper eller leasar en laddbar Kia erbjuder vi dig att teckna ett rabatterat elavtal med vår samarbetspartner Boo Energi. Du får 100 kr rabatt i månanden i tre år, och ett elavtal med 100 % förnybar el från sol, vind och vatten.',
  links: [
    {
      url: 'https://www.kia.com/se/elbil/booenergi/',
      label: 'Läs mer om vårt samarbete med Boo Energi',
      openInNewTab: false,
      widthClass: 'w-full max-w-[380px]',
    },
  ],
};

export const kiaImage100Page02 = {
  src: 'https://kia-afonso-storage.b-cdn.net/100procent/Ladda-100-procent.jpg',
  alt: 'KIA Car',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 py-4 w-full ',
};

export const twoComponentsTextandImg100Page03 = {
  title: 'Ladda på väg med Kia Charge.',
  text: 'Med Kia Charge får du tillgång till hundratusentals laddstationer över hela Europa och kan uppleva bekväm och smidig laddning oavsett var du är. Du laddar via appen Kia Charge eller Kia Charge-kortet och kostnaden för alla laddsessioner samlas på en faktura. I appen ser du pris, tillgänglighet och effekt. Kia sammanställar all el som laddas via Kia Charge och köper motsvarande mängd förnybar el i form av ursprungsintyg (Guarantee of Origin), något som kontrolleras och säkerställs av en oberoende tredjeparts-organisation. ',
  links: [
    {
      url: 'https://kiacharge.com/web/sv/kia-se/service',
      label: 'Anslut till Kia Charge nu',
      openInNewTab: false,
    },
  ],
};

export const kiaImage100Page03 = {
  src: 'https://kia-afonso-storage.b-cdn.net/100procent/Kia%20Charge.jpg',
  alt: 'KIA Car',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 py-4 w-full ',
};

export const twoComponentsTextandImg100Page04 = {
  title: 'Våra hållbarhetsrapporter.',
  text: 'Varje år publicerar vi hållbarhetsrapporter där vi sammanställer det gångna årets insatser. I den globala rapporten kan du läsa om de globala satsningarna och i Kia Sveriges hållbarhetsrapport lyfter vi de aspekter som har en direkt koppling till vår affär, våra kärnvärden och vår verksamhet i Sverige.',
  links: [
    {
      url: 'https://worldwide.kia.com/int/company/sustainability/sustainability-report',
      label: 'Ladda ner Kias globala hållbarhetsrapport.',
      openInNewTab: false,
      widthClass: 'w-full max-w-[380px]',
    },
  ],
};

export const kiaImage100Page04 = {
  src: 'https://kia-afonso-storage.b-cdn.net/100procent/Hallbarhetsrapport-Kia.jpg',
  alt: 'KIA Car',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 py-4 w-full ',
};

export const centerText = {
  title: 'Utökad elbilsstrategi och fler modeller.',
  text: 'Kia utökar sin elbilsstrategi och breddar sitt modellprogram. Det innebär att det snart kommer att finnas en laddbar Kia för alla, i alla segment. Alla kommande och nuvarande elbilar från Kia bygger på plattformen E-GMP, som innebär att nya modeller kan utvecklas modulärt på samma grund oavsett vilket segment de tillhör. Fördelarna är flera, bland annat är plattformen utformad med lång hjulbas och plant golv vilket bidrar till rymlig interiör. Andra fördelar är att den helelektriska drivlinan också har lång räckvidd och snabbladdning som sitt signum. Samma plattformsprincip ligger till grund för utvecklingen av transportbilssegmentet PBV. Plattformen kallas då för E-GMP.S.',
  link: {
    url: 'https://www.kia.com/se/om-kia/inspiredbykia/2025-ev-day/',
    label: 'Läs mer om kommande bilmodeller',
    openInNewTab: false,
  },
};

export const kiaImage100Page05 = {
  src: 'https://kia-afonso-storage.b-cdn.net/100procent/Elbilsstrategi.jpg',
  alt: 'KIA Car',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 py-4 w-11/12 lg:w-full',
};
